import { render, staticRenderFns } from "./TagsFormulario.vue?vue&type=template&id=3752e22d"
import script from "./TagsFormulario.vue?vue&type=script&lang=js"
export * from "./TagsFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports